// $(document).ready(function() {
//   var data_size = $(".splide__list_").attr('data-size');
//   console.log(data_size);
//   if(data_size  > 1 ){
//     function getCheckedValue() {
//         var selectedValue = $('.swatch-item_[name="Color"]:checked').val(); // Get the checked value
//         return selectedValue;
//     }
//     function updateSlider() {
//         var selectedValue = getCheckedValue();
//         if ($('.splide__list_').hasClass('slick-initialized')) {
//             $('.splide__list_').slick('unslick');
//         }

//         var imageCount = 0; 
//         $(".splide__list_ li").remove();

//         $('.hide_mt li').each(function() {
//             var our_ddvar = $(this).clone(); 
//             var data_alt = $(this).find('img').attr('alt');
             
//             if (data_alt === selectedValue || data_alt === undefined || data_alt === '') {
//                 console.log('Selected alt:', data_alt);
//                 $(this).parents('.splide__list').addClass('showing_images');
//                 $(our_ddvar).appendTo('.splide__list_');
//                 imageCount++; 
//             } else {
//                 $(this).parents('.splide__list').removeClass('showing_images');
//             }
//         });
//         if (imageCount > 1 && window.matchMedia('(max-width: 768px)').matches) {
//             setTimeout(function() {
//                 $('.splide__list_').slick({
//                     dots: true,
//                     infinite: true,
//                     arrows: true
//                 });
//             }, 100);
//         }
//     }
//     $('.swatch-item_[name="Color"]').on('change', updateSlider);
//     updateSlider();
//   }
// });
$(document).ready(function() {
  var data_size = $(".splide__list_").attr('data-size');
  console.log(data_size);
  if(data_size  > 1 ){
    function getCheckedValue() {
        var selectedValue = $('.swatch-item_[name="Color"]:checked').val(); // Get the checked value
        return selectedValue;
    }
    function updateSlider() {
        var selectedValue = getCheckedValue();
        // if ($('.splide__list_').hasClass('slick-initialized')) {
        //     $('.splide__list_').slick('unslick');
        // }

        var imageCount = 0; 
        // $(".splide__list_ li ").hide();

        $('.splide__list_ li').each(function() {
            var our_ddvar = $(this).clone(); 
            var data_alt = $(this).find('img').attr('alt');
             
            if (data_alt === selectedValue || data_alt === undefined || data_alt === '') {
                // console.log('Selected alt:', data_alt);
                $(this).addClass('showing_images');
                // $(our_ddvar).appendTo('.splide__list_');
                imageCount++; 
            } else {
                $(this).removeClass('showing_images');
            }
        });
        if (imageCount < 1 && window.matchMedia('(max-width: 768px)').matches) {
            setTimeout(function() {
            $(".showing_images").css("width", "100%"); 
            }, 100);
        }
      var showingImagesCount = $('.splide__list_ li.showing_images').length;
      console.log('Count of showing_images:', showingImagesCount);
      if (showingImagesCount === 1) {
           $(".showing_images").css("width", "100%"); 
      }
    }
    $('.swatch-item_[name="Color"]').on('change', updateSlider);
    updateSlider();
  }
});
